export default __webpack_public_path__ + "static/media/last.b9990599.jpg";